/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */

const PROVINCES = ['RM','MI','NA','TO','FI','BO','GE','VE','TS','PA','CT','BA','CA','SS','PG','AN','AQ','PE','CB','PZ','MT','RC','CS','CZ','KR','VV','TP','AG','CL','EN','ME','SR','RG','LE','TA','FG','BR','BT','CE','AV','BN','SA','IS','FR','LT','RI','VT','TR','GR','LI','LU','MS','PT','PO','SI','PI','FE','FC','RA','RE','MO','PR','PC','MN','BS','BG','CO','LC','LO','PV','CR','MB','SO','VA','VB','NO','VC','BI','AO','AT','AL','CN','PN','UD','GO','TN','BZ','VR','VI','PD','TV','BL','RO','SP','IM','SV','AR','MC','FM','AP','OR','NU','SU'];

/** Sorted + deduped once at module load. */
export const PROVINCES_SORTED = Array.from(new Set(PROVINCES)).sort();

export const PROFESSIONS = [
  { value: 'medico', label: 'Medico chirurgo / Odontoiatra' },
  { value: 'infermiere', label: 'Infermiere' },
  { value: 'psicologo', label: 'Psicologo' },
  { value: 'nutrizionista', label: 'Biologo nutrizionista' },
  { value: 'fisioterapista', label: 'Fisioterapista' },
  { value: 'ostetrica', label: 'Ostetrica/o' },
  { value: 'osteopata', label: 'Osteopata' },
  { value: 'oss', label: 'OSS' },
];
